import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import s from './styles/Toast.module.scss'

const Toast = ({
	isVisible,
	message,
	duration = 2000,
	onClose,
	type = 'success',
}) => {
	const [isShowing, setIsShowing] = useState(false)

	useEffect(() => {
		if (isVisible) {
			setIsShowing(true)
			const timer = setTimeout(() => {
				setIsShowing(false)
				setTimeout(() => {
					onClose?.()
				}, 300) // Wait for fade out animation
			}, duration)

			return () => clearTimeout(timer)
		}
	}, [isVisible, duration, onClose])

	if (!isVisible && !isShowing) return null

	return createPortal(
		<div
			className={`${s.toast} ${s[type]} ${isShowing ? s.visible : s.hidden}`}
		>
			<div className={s.icon}>
				<CheckIcon />
			</div>
			<span className={s.message}>{message}</span>
		</div>,
		document.body
	)
}

export default Toast
